const PAGE_MESSAGE_TYPE = "HRMS_ATTENDANCE_EXTENSION_CONTROL";
const PAGE_EVENT_TYPE = "HRMS_ATTENDANCE_EXTENSION_EVENT";

function postControlMessage(action, payload = {}) {
  if (typeof window === "undefined" || typeof window.postMessage !== "function") {
    return false;
  }

  window.postMessage(
    {
      source: "hrms-web-app",
      type: PAGE_MESSAGE_TYPE,
      action,
      payload,
    },
    window.location.origin
  );

  return true;
}

export function syncAttendanceExtensionState(payload) {
  return postControlMessage("sync_state", payload);
}

export function clearAttendanceExtensionState(payload = {}) {
  return postControlMessage("clear_state", payload);
}

export function pingAttendanceExtension() {
  return postControlMessage("ping");
}

export function subscribeToAttendanceExtensionEvents(listener) {
  if (typeof window === "undefined" || typeof listener !== "function") {
    return () => {};
  }

  const handleMessage = (event) => {
    if (event.source !== window || !event.data || event.data.type !== PAGE_EVENT_TYPE) {
      return;
    }

    listener(event.data.payload || {});
  };

  window.addEventListener("message", handleMessage);

  return () => {
    window.removeEventListener("message", handleMessage);
  };
}

